<template>
  <div class="base_info">
    <div class="header">
      <div class="iconBox" @click="toOrderList">
        <img :src="orderBtn" alt="">
        <span>我的订单</span>
      </div>
    </div>
    <div class="info_form" v-if="this.comName!=='HE_BEI_02'">
      <div class="info_title">
        <img :src="zsb_H5MotorLocation" alt="">
        <span>业务归属</span>
      </div>
      <div class="info_content">
        <!-- <van-cell-group :border="false">
          <van-field v-model="baseInfo.provinceName" :border="true" readonly input-align="right" right-icon="location-o" label="投保地区" />
        </van-cell-group> -->
        <van-field v-model="baseInfo.provinceName" :is-link ='isLink' required readonly input-align="right" label="投保地区" @click="isShowMotorArea" :disabled = 'isDisabled' />
      </div>
    </div>
    <div class="info_form" v-if="this.comName==='HE_BEI_02'">
      <div class="info_title">
        <img :src="zsb_H5MotorLocation" alt="">
        <span>业务归属</span>
      </div>
      <div class="info_content">
        <!-- <van-cell-group :border="false">
          <van-field v-model="baseInfo.provinceName" :border="true" readonly input-align="right" right-icon="location-o" label="投保地区" />
        </van-cell-group> -->
        <van-field v-model="baseInfo.provinceName" :is-link = 'isLink' required readonly input-align="right" label="投保地区" @click="showHeNanArea=true" :disabled = 'isDisabled' />
      </div>
    </div>
    <div class="info_form form_two">
      <div class="info_title info_two">
        <div class="left_box">
          <img :src="zsb_H5MotorCar_info" alt="">
          <span>车辆信息录入</span>
        </div>
        <div v-show="newCarFlag === '1' && isShowOCR" class="right_box">
          <div class="left_tab" :class="identifyType === '1' ? 'active' : ''" @click="changeType('1')">
            行驶证
          </div>
          <div class="right_tab" :class="identifyType === '0' ? 'active' : ''" @click="changeType('0')">
            合格证
          </div>
        </div>
      </div>
      <div class="info_content">
        <div v-if="isShowOCR" class="identify-area">
          <div v-show="!showNewImg" @change="handleFile($event)">
            <input ref="fileBtn" type="file" class="refesh-input-file" accept="image/*">
          </div>
          <div v-if="!showNewImg" class="img-content">
            <img :src="zsb_H5MotorNew_camera" alt="">
            <p>
              {{ identifyType === '1' ? '点击上传行驶证照片' : '点击上传合格证照片' }}
            </p>
          </div>
          <div v-if="showNewImg" class="new-img">
            <img ref="currentImg" :src="ocrImag" alt="">
          </div>
          <div v-if="showTips" class="tips">
            <div class="img-tip">
              <img :src="imgUrlLeftTarget" alt="" class="left-img">
              <img :src="imgUrlRightTarget" alt="" class="right-img">
            </div>
            <div class="text-tips">
              <p>可放大、上下滑动<span class="line">|</span>关闭<img :src="imgUrlClose" alt="" class="close-img" @click="closeTips()"></p>
            </div>
          </div>
          <div v-if="showNewImg" class="tool-list">
            <div class="refesh" @change="handleFile($event)">
              <input ref="fileBtn" type="file" class="refesh-input-files" accept="image/*">
              <img :src="imgUrlRefresh" alt="">
            </div>
            <img :src="imgUrlSpinner" alt="" @click="rotateImg">
            <img :src="imgUrlEnlarge" alt="" @click="enlargeImg">
          </div>
        </div>
        <van-cell-group :border="false">
          <van-field v-model="licenseNo" class="extra_label" required placeholder="请输入车牌号" :maxlength="this.comName === 'NING_BO' || this.comName === 'XIA_MEN' ? 5 : 6" @blur="licenseNoBlur" v-if="this.comName!=='HE_BEI_02'">
            <template #label>
              <div class="labe_box">
                <span>车牌号</span>
                <div>
                  <span>{{licenseNoName}}</span><span class="line" />
                </div>
              </div>
            </template>
            <template #right-icon>
              <div class="new_icon" @click="changeCarFlag(newCarFlag)">
                <van-icon v-if="newCarFlag === '0'" size="0.18rem" name="circle" @click="newCarFlag = '1'" />
                <van-icon v-else name="checked" size="0.18rem" color="#5e2686" @click="newCarFlag = '0'" />
                <span>未上牌</span>
              </div>
            </template>
          </van-field>
          <van-field name="radio" label="车牌号" required v-if="this.comName==='HE_BEI_02'" v-model="baseInfo.licenseNo" class="hebeiLicen" maxlength="7">
          <template #right-icon>
            <div class="new_icon" @click="changeCarFlag(newCarFlag)">
              <van-icon v-if="newCarFlag === '0'" size="0.18rem" name="circle" @click="newCarFlag = '1'" />
              <van-icon v-else name="checked" size="0.18rem" color="#5e2686" @click="newCarFlag = '0'" />
              <span>未上牌</span>
            </div>
          </template>
        </van-field>
          <van-field v-model="baseInfo.brandName" required input-align="right" label="品牌型号" placeholder="请输入品牌型号" @input="changName" />
          <van-field v-model="baseInfo.oriModelName" required readonly input-align="right" label="厂牌车型" is-link @click="toModelList()" />
          <van-field v-model="baseInfo.vINNo" required input-align="right" placeholder="请输入车架号" @input="changVINNo">
            <template #label>
              <div class="vin_box left_extra">
                <span>车架号</span>
                <span>VIN码</span>
              </div>
            </template>
          </van-field>
          <van-field v-model="baseInfo.engineNo" required input-align="right" label="发动机号" placeholder="请输入发动机号" @input="changEngineNo" />
          <van-field v-model="baseInfo.enrollDate" readonly required input-align="right" placeholder="请选择" is-link @click="ShowRegist">
            <template #label>
              <div class="left_extra">
                <span>注册日期</span>
                <span>初登日期</span>
              </div>
            </template>
          </van-field>
          <van-field v-model="baseInfo.updateEnrollDate" readonly required input-align="right" placeholder="请选择" is-link @click="ShowAdjust">
            <template #label>
              <div class="left_extra time_box">
                <span>注册日期调整</span>
                <span>初登日期调整</span>
              </div>
            </template>
          </van-field>
        </van-cell-group>
        <p class="tab_title">
          车辆种类
        </p>
        <div class="type_list">
          <div class="type-item" :class="motorType === '0' ? 'type_active' : ''" @click="motorTypeClick ('0')">
            普通二轮摩托车
          </div>
          <div class="type-item" :class="motorType === '1' ? 'type_active' : ''" @click="motorTypeClick ('1')">
            三轮摩托车
          </div>
        </div>
        <div class="type_list" style="margin-top:.06rem" v-if="this.comName !== 'SHAN_XI'">
          <div class="type-item" :class="motorType === '2' ? 'type_active' : ''" @click="motorTypeClick ('2')">
            电动二轮摩托车
          </div>
          <div class="type-item" :class="motorType === '3' ? 'type_active' : ''" @click="motorTypeClick ('3')">
            电动三轮摩托车
          </div>
        </div>
        <van-cell-group :border="false">
          <van-field v-model="baseInfo.printModelName" label="打印车型" required input-align="right" placeholder="请输入打印车型" />
          <van-field v-model="carKindDetailName" label="车种明细" readonly required input-align="right" is-link @click="showCarKindDetail = true" />
          <van-field v-model="useNatureName" label="车辆使用性质" required input-align="right" disabled />
          <div class="color_group">
            <van-field v-model="baseInfo.seatCount" label="座位数" required input-align="right" placeholder="请输入座位数" />
            <!-- <van-field v-model="baseInfo.useNatureCode" label="车辆使用性质" required input-align="right" placeholder="请输入车辆使用性质" disabled/> -->
            <van-field v-model="colorCodeName" label="车身颜色" readonly required input-align="right" is-link @click="showColorCodeFlag = true" />
            <van-field v-model="baseInfo.exhaustCapacity" label="排量（ml）" required input-align="right" placeholder="请输入排量" />
            <van-field v-model="baseInfo.power" label="功率（kw）" required input-align="right" placeholder="请输入功率" />
            <van-field v-model="baseInfo.speed" label="时速（km/h）" required input-align="right" placeholder="请输入时速" />
            <van-field v-model="baseInfo.tonCount" label="吨位（t）" required input-align="right" placeholder="请输入吨位" />
            <van-field v-model="baseInfo.completekerbmass" label="整备质量（kg）" required input-align="right" placeholder="请输入整备质量" />
            <van-field v-model="baseInfo.purchasePrice" label="新车购置价（￥）" required input-align="right" placeholder="请输入新车购置价" />
            <van-field v-model="licenseKindName" label="号牌种类" readonly required input-align="right" is-link @click="showLicenseKind = true" />
            <van-field v-model="licenseColorName" label="号牌底色" readonly required input-align="right" is-link @click="showLicenseColor = true" />
            <van-field v-model="oriCarKindName" label="车辆类型" readonly required input-align="right" is-link @click="showCarType = true" />
            <van-field v-model="specialCarFlagName" label="特殊车辆标志" readonly required input-align="right" is-link @click="showSpecialCarFlag = true" />
            <van-cell title="是否过户" center required>
              <template #right-icon>
                <van-switch :value="baseInfo.carLoanFlag" active-value="1" nactive-value="0" size="0.20rem" active-color="#5e2686" inactive-color="#dcdee0" @input="guohuChange" />
              </template>
            </van-cell>
            <van-field v-show="baseInfo.carLoanFlag === '1'" v-model="baseInfo.makeDateJQ" label="过户登记日期" readonly required input-align="right" placeholder="请选择" is-link @click="showTransfer" />
            <!-- <van-field v-model="baseInfo.contractNo" label="车队协议号" input-align="right" placeholder="请输入车队协议号" /> -->
          </div>
        </van-cell-group>
      </div>
    </div>
    <div class="bottom_box">
      <div class="btn btnTop" style="margin-right:.1rem" @click="temporary">
        暂存
      </div>
      <div class="btn" @click="submit">
        下一步
      </div>
    </div>
    <van-popup v-model="dateVisble" position="bottom" close-on-click-overlay>
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="dateSure"
        @cancel="dateVisble = false"
        @change="changSure"
      />
    </van-popup>
    <van-popup v-model="showCarKindDetail" position="bottom">
      <van-picker
        show-toolbar
        :columns="carKindDetailColumns"
        @confirm="confirm($event,'carKindDetail')"
        @cancel="showCarKindDetail = false"
      />
    </van-popup>
    <van-popup v-model="showCarType" position="bottom">
      <van-picker
        show-toolbar
        :columns="carTypeColumns"
        @confirm="confirm($event,'oriCarKind')"
        @cancel="showCarType = false"
      />
    </van-popup>
    <van-popup v-model="showLicenseKind" position="bottom">
      <van-picker
        show-toolbar
        :columns="licenseKindColumns"
        @confirm="confirm($event,'licenseKind')"
        @cancel="showLicenseKind = false"
      />
    </van-popup>
    <van-popup v-model="showLicenseColor" position="bottom">
      <van-picker
        show-toolbar
        :columns="licenseColorColumns"
        @confirm="confirm($event,'licenseColor')"
        @cancel="showLicenseColor = false"
      />
    </van-popup>
    <van-popup v-model="showSpecialCarFlag" position="bottom">
      <van-picker
        show-toolbar
        :columns="specialCarFlagColumns"
        @confirm="confirm($event,'specialFlag')"
        @cancel="showSpecialCarFlag = false"
      />
    </van-popup>
    <van-popup v-model="showMotorArea" position="bottom">
      <van-picker
        show-toolbar
        :columns="motorAreaColumns"
        @cancel="showMotorArea = false"
        @confirm="areaConfirm"
      />
    </van-popup>
    <van-popup v-model="showColorCodeFlag" position="bottom">
      <van-picker
        show-toolbar
        :columns="colorCodeColumns"
        @confirm="confirm($event,'colorCode')"
        @cancel="showColorCodeFlag = false"
      />
    </van-popup>
    <Loading :switchs="switchs" />
    <!-- 城市弹出层 -->
    <van-popup v-model="showHeNanArea" position="bottom" :style="{ height: '40%' }">
      <van-area :area-list="areaList" :columns-num="2"  @confirm="areaConfirmList" @cancel="showHeNanArea=false" />
    </van-popup>
  </div>
</template>

<script>
import api from '@/api/api.js'
import checkFormat from '@/utils/checkFormat.js'
import { getImgBase64 } from '@/utils/imgBlobToBase64.js'
import Loading from '@/components/Loadings/Loading'
import Compressor from 'compressorjs'
import { Toast, Dialog } from 'vant'
import { motorReminder, areaDetail } from '@/utils/const.js'
import { removeWatermark, setWaterMark } from '../../watermark'
export default {
  components: {
    Loading
  },
  data() {
    return {
      orgBackground: '',
      showMotorArea: false, // 地区弹框
      motorAreaColumns: [], // 地址数组
      imgUrlEnlarge: api.imgAllUrl + '/img-enlarge.png',
      imgUrlRefresh: api.imgAllUrl + '/img-refesh.png',
      imgUrlSpinner: api.imgAllUrl + '/img-spin.png',
      imgUrlLeftTarget: api.imgAllUrl + '/left-target.png',
      imgUrlRightTarget: api.imgAllUrl + '/right-target.png',
      imgUrlClose: api.imgAllUrl + '/img-close.png',
      orderBtn: api.imgAllUrlZSB + '/order-btn.png',
      showTips: false,
      identifyType: '1',
      newCarFlag: '0',
      motorType: '0',
      dateStatus: '',
      showNewImg: false,
      ocrImag: '',
      dateVisble: false,
      currentDate: '',
      minDate: new Date(2000, 1, 1), // 日期选择器最小显示日期
      maxDate: '',
      ISchecked: false,
      baseInfo: {
        proposalCityCode: '', // 城市code
        provinceCode: '',
        provinceName: '',
        licenseNo: '', // 车牌号
        noLicenseFlag: '1',
        brandName: '', // 品牌型号
        oriModelName: '', // 厂牌车型
        vINNo: '', // 车架号
        engineNo: '', // 发动机号
        enrollDate: '', // 注册日期
        updateEnrollDate: '', // 注册日期调整
        carKindCode: 'M0',
        printModelName: '',
        carKindDetailId: '',
        seatCount: '',
        exhaustCapacity: '',
        power: '',
        tonCount: '',
        completekerbmass: '',
        purchasePrice: '',
        licenseKindCode: '07',
        licenseColorCode: '01',
        oriCarKindName: 'M21',
        netWorkCode: '',
        // contractNo: '',
        carLoanFlag: '0', // 交强特殊车辆标志
        chgOwnerFlag: '0', // 商业险是否过户车标志 0--否 1--是
        makeDateJQ: '', // 过户登记日期
        speed: null, // 时速
        useNatureCode: '87',
        colorCode: '' // 车身颜色
      },
      useNatureName: '非营业',
      licenseNo: '',
      carKindDetailName: '',
      showCarKindDetail: false,
      carKindDetailColumns: [],
      oriCarKindName: 'M21-普通二轮摩托车',
      showCarType: false,
      carTypeColumns: [],
      licenseKindName: '两、三轮摩托车号牌',
      showLicenseKind: false,
      licenseKindColumns: [],
      licenseColorName: '01-蓝',
      showLicenseColor: false,
      licenseColorColumns: [],
      showSpecialCarFlag: false,
      specialCarFlagName: '正常车辆投保',
      specialCarFlagColumns: [],
      dictionaryData: [],
      colorCodeName: '', // 车身颜色
      colorCodeColumns: [], // 车身颜色
      showColorCodeFlag: false, // 车身颜色
      displacement: {
        scalar: 1,
        moveEnd: false
      },
      switchs: false,
      imgobjs: {
        fileId: '',
        fileType: '',
        fileName: ''
      },
      zsb_H5MotorLocation: api.imgAllUrlZSB + '/zsb_H5MotorLocation.png',
      zsb_H5MotorCar_info: api.imgAllUrlZSB + '/zsb_H5MotorCar_info.png',
      zsb_H5MotorNew_camera: api.imgAllUrlZSB + '/zsb_H5MotorNew_camera.png',
      isBrandName: false, // 品牌型号
      isvINNo: false, // 车架号修改
      isEngineNo: false, // 发动机号
      isRegist: false,
      isAdjust: false,
      comName: '', // 机构名
      comCode: '', // 机构代码
      licenseNoName: '', // 车牌号第一位
      cInfo: '',
      // nextNum: 0,
      imgUrl: api.imgIdUrl,
      sendChanges: false, // 下发修改的
      orderNo: '',
      nextNum: 0,
      isDisabled: true,
      isLink: false,
      imgDeg: 0,
      showHeNanArea: false, // 地区弹框
      areaList: {
        province_list: {},
        city_list: {}
      },
      isShowOCR: null, // 是否显示ocr
      userToken: ''
    }
  },
  watch: {
    // 1未上牌
    'newCarFlag': function(newval, oldVal) {
      // if (this.lastImg && this.lastImg.length === 0) {
      //   this.identifyType = (newval === '0' ? '1' : '0')
      //   this.clearDate()
      // }
      this.identifyType = (newval === '0' ? '1' : '0')
    },
    ocrImag: {
      handler(newVal, oldVal) {
        if (this.showNewImg && this.identifyType === '0') {
          this.showTips = true
        }
      },
      deep: true,
      immediate: true
    },
    // 'motorType': function(newval, oldVal) {
    //   // console.log(newval, '------------->');
    //   if (newval) {
    //     this.carKindDetailName = ''
    //     this.baseInfo.carKindDetailId = ''
    //   }
    //   // this.baseInfo.carKindCode = (newval === '0' ? 'M0' : 'M2')
    //   this.baseInfo.carKindCode = newval === '0' ? 'M0' : newval === '1' ? 'M2' : newval === '2' ? 'M5' : 'M6'
    //   this.carKindDetailColumns = []
    //   this.dictionaryData.forEach(item => {
    //     if (item.upperCode === this.baseInfo.carKindCode) {
    //       const detailObj = {
    //         text: item.codecname,
    //         code: item.codeCode
    //       }
    //       this.carKindDetailColumns.push(detailObj)
    //       // console.log(this.carKindDetailColumns, 'this.carKindDetailColumns');
    //     }
    //   })
    // },
    'licenseNo': function(newVal, oldVal) {
      // console.log(newVal,'newVal');
      this.licenseNo = newVal.toUpperCase()
    }
  },
  created() {
    this.userToken = localStorage.getItem('setToken') || checkFormat.getUrlKey('token')
    this.queryDictionary()
    // console.log(this.$store.state.motorOrderDetail, '----0000')
    if (localStorage.getItem('cInfo')) {
      this.cInfo = JSON.parse(localStorage.getItem('cInfo'))
      const comName = localStorage.getItem('setMotorAreaName')
      if (comName === 'SHAAN_XI') {
        this.$http.get(`${api.buryPoint}?locationPointId=${api.pointOBj.basePoint}&userId=${this.cInfo.phoneNumber}`).then(res => {
          if (res.data.code === 200) {
            console.log('基础信息埋点成功')
          }
        })
      }
    }
    this.comName = localStorage.getItem('setMotorAreaName')
    console.log(this.comName, '那个城市啊')
    this.getUpProvinceCom()
  },
  mounted() {
  // 陕西610000 河南410000 河北130000 福建350000 浙江330000/宁波330200
    // console.log(areaDetail,' areaDetail');
    areaDetail.forEach(El => {
      if (El.comName === this.comName) {
        this.comCode = El.comCode
        this.isShowOCR = El.isShowOCR
        if (this.comName !== 'HE_BEI_02') {
          this.licenseNoName = this.comName === 'NING_BO' ? El.licenseNoName + 'B' : this.comName === 'XIA_MEN' ? El.licenseNoName + 'D' : El.licenseNoName
        }
      }
    })
    console.log(this.isShowOCR, 'isShowOCRisShowOCR')
    // console.log(this.comCode, 'this.comCode')
    if (this.comCode === '330000') {
      this.baseInfo.provinceName = '宁波'
      this.baseInfo.proposalCityCode = '330200'
      this.isDisabled = true
      this.isLink = false
    } else if (this.comName === 'XIA_MEN') {
      this.baseInfo.provinceName = '厦门'
      this.baseInfo.proposalCityCode = '350200'
      this.isDisabled = true
      this.isLink = false
    } else {
      this.isDisabled = false
      this.isLink = true
    }
    localStorage.setItem('proposalCityCode',this.baseInfo.proposalCityCode)
    this.$store.commit('set_motorOrderId', '')
    this.$store.commit('setBaseInfo', '')
    this.$store.commit('setVehicleInfo', '')
    this.$store.commit('setCarOwnerInfo', '')
    this.$store.commit('setInsuredList', '')
    this.$store.commit('setItemkindList', '')
    this.$store.commit('setItemFileDataList', [])
    this.$store.commit('setEngageList', '')
    // this.$store.commit('set_motorOrderDetail', {})
    this.$store.commit('set_motorBaseInfo', {})
    if (this.showNewImg && this.identifyType === '0') {
      this.showTips = true
    }
    // this.eleMotorViewConfig() //暂定查不到comCode
  },
  activated() {
    // console.log(this.$store.state.motorOrderDetail, '00000000')
    this.isBrandName = false
    this.isvINNo = false
    this.isEngineNo = false
    this.isAdjust = false
    this.isRegist = false
    this.$store.commit('set_motorStep', '1')
    this.$store.commit('set_showStep', true)
    this.returnData = this.$route.params
    // console.log(this.baseInfo.provinceName);
    this.baseInfo.insuredAreaCN = this.baseInfo.provinceName
    // console.log(this.returnData, '===1')
    if (localStorage.getItem('cInfo')) {
      this.cInfo = JSON.parse(localStorage.getItem('cInfo'))
      this.cInfo.name = checkFormat.hideInsurantName(1, this.cInfo.name)
      this.cInfo.identifyNum = checkFormat.hideInsurantName(3, this.cInfo.identifyNum)
      setWaterMark(this.cInfo.name + '-' + this.cInfo.identifyNum)
    }
    if (this.returnData && Object.keys(this.returnData).length > 0 && this.returnData.result && Object.keys(this.returnData.result).length > 0) {
      this.baseInfo.seatCount = this.returnData.result.seatCount
      this.baseInfo.exhaustCapacity = checkFormat.isEmpty(this.returnData.result.exhaustCapacity) ? '0' : this.returnData.result.exhaustCapacity
      this.baseInfo.tonCount = checkFormat.isEmpty(this.returnData.result.vehicleTonnage) ? '0' : (this.returnData.result.vehicleTonnage / 1000)
      this.baseInfo.completekerbmass = checkFormat.isEmpty(this.returnData.result.vehicleWeight) ? '0' : this.returnData.result.vehicleWeight
      this.baseInfo.purchasePrice = (this.returnData.result.productStatus === '停产' && Number(this.returnData.result.kindredPrice) > 0) ? this.returnData.result.kindredPrice : this.returnData.result.purchasePrice
      this.baseInfo.oriModelName = this.returnData.result.modelName
      this.baseInfo.brandName = this.returnData.result.modelName
      this.baseInfo.printModelName = this.returnData.result.platModelName
      this.baseInfo.platVehicleCode = this.returnData.result.platVehicleCode
      this.baseInfo.vehicleId = this.returnData.result.vehicleId
      this.baseInfo.importFlag = this.returnData.result.importFlag
      this.baseInfo.import_Flag = this.returnData.result.import_Flag
      this.baseInfo.power = this.returnData.result.power ? this.returnData.result.power : this.baseInfo.power
      this.baseInfo.modelCode = this.returnData.result.modelCode
      this.baseInfo.certificateDate = this.returnData.result.certificateDate
      this.baseInfo.issueDate = this.returnData.result.issueDate
      this.baseInfo.remark = this.returnData.result.remark
      // this.baseInfo.useNatureCode = '非营业'
      this.orderNo = this.returnData.orderNo
      localStorage.setItem('vehicleId', this.returnData.result.vehicleId)
    }
  },
  deactivated() {
    removeWatermark()
  },
  methods: {
    areaConfirmList(value) {
      console.log(value, '000000')
      // this.baseInfo.proposalAreaCode = value[0].code
      this.baseInfo.proposalCityCode = value[1].code
      this.baseInfo.provinceName = value[0].name + ',' + value[1].name
      this.showHeNanArea = false
    },
    motorTypeClick(type) {
      this.carKindDetailName = ''
      this.baseInfo.carKindDetailId = ''
      this.motorType = type
      this.baseInfo.carKindCode = type === '0' ? 'M0' : type === '1' ? 'M2' : type === '2' ? 'M5' : 'M6'
      this.carKindDetailColumns = []
      this.dictionaryData.forEach(item => {
        if (item.upperCode === this.baseInfo.carKindCode) {
          const detailObj = {
            text: item.codecname,
            code: item.codeCode
          }
          this.carKindDetailColumns.push(detailObj)
          // console.log(this.carKindDetailColumns, 'this.carKindDetailColumns');
        }
      })
    },
    // eleMotorViewConfig() { //暂定查不到comCode
    //   this.$http.get(`${api.eleMotorViewConfig}?comCode=${this.comCode}&riskCode=0591`).then(res => {
    //     console.log(res, 'TaxRes');
    //   })
    // },
    changeCarFlag(type) {
      console.log(type, 'type')
      this.clearDate()
    },
    isShowMotorArea() {
      this.showMotorArea = this.licenseNoName !== '浙B' && this.licenseNoName !== '闽D'
    },
    temporary(type) { // 下一步也得暂存
      console.log(this.orderNo, 'temporary')
      // console.log(this.$store.state.motorOrderId, 'this.$store.state.motorOrderId')
      this.baseInfo.noLicenseFlag = this.newCarFlag === '1' ? '0' : '1'
      this.baseInfo.insuredAreaCN = this.baseInfo.provinceName
      this.baseInfo.vehicleStyleUniqueId = ''
      if (this.licenseNo && this.comName !== 'HE_BEI_02') {
        this.baseInfo.licenseNo = `${this.licenseNoName}${this.licenseNo}`
      }
      const data = {
        orderId: this.$store.state.motorOrderId,
        terminalId: 'H5',
        orderOrigin: 'DP_OWXPA',
        channelCode: 'DP_OWXPA',
        productCode: 'motor_product',
        productName: '摩托车险',
        itemFileDataList: [],
        vehicleInfo: this.baseInfo,
        orderNo: this.orderNo,
        baseInfo: {
          channelCode: 'DP_OWXPA'
        }

      }
      data.vehicleInfo.useNatureCode = '87'
      const JQfile = {
        businessNo: null,
        riskCode: '0591' // 交强险code
        // fileList: []
      }
      // console.log(this.imgobjs, 'imgobjs')
      // console.log(this.$store.state.itemFileDataList, 'itemFileDataList')
      if (this.imgobjs.fileId !== '') {
        let imageInfoLists = []
        if (this.$store.state.itemFileDataList && this.$store.state.itemFileDataList.length > 0 && this.$store.state.itemFileDataList[0].fileList.length > 0 && this.$store.state.itemFileDataList[0].fileList[0].fileId !== '') {
          this.$store.state.itemFileDataList[0].fileList.forEach(value => {
            imageInfoLists.push({
              fileId: value.fileId,
              fileType: value.fileType,
              fileName: value.fileName
            })
          })
        }
        imageInfoLists.push(this.imgobjs)
        imageInfoLists = this.reduces(imageInfoLists)
        // console.log(imageInfoLists, 'imageInfoLists')
        if (imageInfoLists.length !== 0) {
          JQfile.fileList = imageInfoLists
          data.itemFileDataList.push(JQfile)
        }
      } else {
        data.itemFileDataList = this.$store.state.itemFileDataList
        // console.log(this.nextNum, '-0000-012300')
      }
      this.nextNum++
      console.log(data, 'data暂存接口的参数')
      // if (type === 'save') {
      //   this.$store.commit('set_motorStep', '2')
      //   this.$store.commit('setItemFileDataList', data.itemFileDataList)
      //   this.$store.commit('set_motorBaseInfo', data.vehicleInfo)
      // } else {
      this.switchs = true
      this.$http.post(api.motorSava, data)
        .then(res => {
          if (res.data.rtnCode === '0000') {
            if (res.data.resultObj.baseInfo) {
              this.$store.commit('set_motorComCode', res.data.resultObj.baseInfo.comCode)
            }
            // console.log(res.data.resultObj.itemFileDataList, '????')
            if (res.data.resultObj.itemFileDataList) {
              this.$store.commit('setItemFileDataList', res.data.resultObj.itemFileDataList)
            }
            this.$store.commit('set_motorBaseInfo', data.vehicleInfo)
            if (type === 'save') {
              this.$store.commit('set_motorStep', '2')
            }
            if (type === 'orderList') {
              this.$router.push('/motor/orderList')
            }
            // this.imgobjs = {
            //   fileId: '',
            //   fileType: '',
            //   fileName: ''
            // }
          } else {
            this.$toast(res.data.rtnMsg)
          }
          this.switchs = false
        })
        .catch(error => {
          console.log(error)
          this.switchs = false
        })
    // }
    },
    reduces(arr) {
      // console.log(arr, 'aee')
      const list = {}
      arr = arr.reduce((total, next) => {
        list[next.fileId] ? '' : list[next.fileId] = true && total.push(next)
        return total
      }, [])
      return arr
    },
    licenseNoBlur(e){
      // console.log('2345',e.target._value);
      // console.log(this.comName, 'this.comName');
      // console.log(e.target._value.startsWith('D'));
      let licenseNo = this.licenseNoName + e.target._value
      if (!checkFormat.isVehicleNumber(licenseNo)) {
        this.$toast('请填写正确的车牌号')
        return false
      } else {
        if (this.comName === 'FU_JIAN' && e.target._value.startsWith('D')) {
          Dialog.alert({
            message: '尊敬的客户：你好，本平台目前仅支持为持有福建地区（不含厦门）机动车行驶证的国产燃油摩托车自然人车主提供交强险便民投保服务，其他车辆如需投保，请线下联系保险公司投保，谢谢！',
            confirmButtonText:'我知道了',
            confirmButtonColor:'#5E2589'
            
          }).then(() => {
            // on close
            // this.licenseNoName = ''
          });
          return false
        }
      }
    },
    getMortorQuery() { // 下发修改数据回显
      console.log('进入回显')
      const returnData = this.$store.state.motorOrderDetail
      this.$store.commit('set_motorOrderId', returnData.orderId)
      this.baseInfo = returnData.vehicleInfo
      // console.log(this.licenseNo,'回显');
      // console.log(this.comName ,'this.comName ');
      if (localStorage.getItem('provinceName')) {
        this.baseInfo.insuredAreaCN = localStorage.getItem('provinceName')
        this.baseInfo.provinceName = localStorage.getItem('provinceName')
      }
      if (this.baseInfo.insuredAreaCN) {
        if (this.comName === 'NING_BO' || this.comName === 'XIA_MEN') {
          const provinceName = this.baseInfo.insuredAreaCN.split(",")
          this.baseInfo.provinceName = provinceName[0]
          this.isDisabled = true
          this.isLink = false
        } else {
          this.baseInfo.provinceName = this.baseInfo.insuredAreaCN
          this.isDisabled = false
          this.isLink = true
          if (this.comName !== 'HE_BEI_02') {
            this.showMotorArea = true
            const provin = this.baseInfo.insuredAreaCN.split(',')
            this.areaConfirm(provin)
          }
        }
      } else {
        this.baseInfo.provinceName = this.comName === 'NING_BO' ? '宁波' : this.comName==='XIA_MEN' ? '厦门' : ''
      }
      if (this.baseInfo.licenseNo && this.comName!=='HE_BEI_02') {
        this.licenseNoName = this.comName === 'NING_BO' || this.comName === 'XIA_MEN' ? this.baseInfo.licenseNo.substring(0,2) : this.baseInfo.licenseNo.substring(0,1)
        this.licenseNo = this.comName === 'NING_BO' || this.comName === 'XIA_MEN' ? this.baseInfo.licenseNo.substring(2) : this.baseInfo.licenseNo.substring(1)
      }
      if (this.baseInfo.carKindCode && this.baseInfo.carKindCode !== null && this.baseInfo.carKindCode !== undefined) {
        this.motorType = this.baseInfo.carKindCode === 'M0' ? '0' : this.baseInfo.carKindCode === 'M2' ? '1' : this.baseInfo.carKindCode === 'M5' ? '2' : '3'
        // console.log(this.baseInfo.carKindCode);
        // console.log(this.motorType);
        this.carKindDetailColumns = []
        this.dictionaryData.forEach(item => {
        if (item.upperCode === this.baseInfo.carKindCode) {
          const detailObj = {
            text: item.codecname,
            code: item.codeCode
          }
          this.carKindDetailColumns.push(detailObj)
        }
      })
      }
      // console.log(this.carKindDetailColumns, 'this.carKindDetailColumns');
      // console.log(this.baseInfo.carKindDetailId, 'this.baseInfo.carKindDetailId');
      this.nextNum = 1
      // 车种明细
      if (this.baseInfo.carKindDetailId && this.baseInfo.carKindDetailId !== null && this.baseInfo.carKindDetailId !== undefined) {
        if (Array.isArray(this.carKindDetailColumns) && this.carKindDetailColumns.length > 0) {
          const carKideName = this.carKindDetailColumns.find(item => {
            return item.code === this.baseInfo.carKindDetailId
          })
          this.carKindDetailName = carKideName.text
        }
      } else {
        this.carKindDetailName = ''
      }
      // 号牌种类
      if (this.baseInfo.licenseKindCode && this.baseInfo.licenseKindCode !== null && this.baseInfo.licenseKindCode !== undefined) {
        if (Array.isArray(this.licenseKindColumns) && this.licenseKindColumns.length > 0) {
          const licenseKind = this.licenseKindColumns.find(item => {
            return item.code === this.baseInfo.licenseKindCode
          })
          this.licenseKindName = licenseKind.text
        }
      } else {
        this.baseInfo.licenseKindCode = '07'
      }
      // 号牌底色
      if (this.baseInfo.licenseColorCode && this.baseInfo.licenseKindCode !== null && this.baseInfo.licenseKindCode !== undefined) {
        if (Array.isArray(this.licenseColorColumns) && this.licenseColorColumns.length > 0) {
          const licenseColor = this.licenseColorColumns.find(item => {
            return item.code === this.baseInfo.licenseColorCode
          })
          this.licenseColorName = licenseColor.text
        }
      } else {
        this.baseInfo.licenseColorCode = '01'
      }
      // 车辆类型
      if (this.baseInfo.oriCarKindName && this.baseInfo.oriCarKindName !== null && this.baseInfo.oriCarKindName !== undefined) {
        if (Array.isArray(this.carTypeColumns) && this.carTypeColumns.length > 0) {
          const oriCarKind = this.carTypeColumns.find(item => {
            return item.code === this.baseInfo.oriCarKindName
          })
          this.oriCarKindName = oriCarKind.text
        }
      } else {
        this.baseInfo.oriCarKindName = 'M21'
      }
      // console.log(this.baseInfo.colorCode, '车身颜色')
      // console.log(this.colorCodeColumns, '车身颜色')
      if (this.baseInfo.colorCode && this.baseInfo.colorCode !== null && this.baseInfo.colorCode !== undefined && this.baseInfo.colorCode !== '') { // 车身颜色
        if (Array.isArray(this.colorCodeColumns) && this.colorCodeColumns.length > 0) {
          const colorCode = this.colorCodeColumns.find(item => {
            return item.code === this.baseInfo.colorCode
          })
          this.colorCodeName = colorCode.text
        }
      }
      // 特殊车辆标志
      if (this.baseInfo.carLoanFlag && this.baseInfo.carLoanFlag !== null && this.baseInfo.carLoanFlag !== undefined) {
        if (Array.isArray(this.specialCarFlagColumns) && this.specialCarFlagColumns.length > 0) {
          const specialCarFlag = this.specialCarFlagColumns.find(item => {
            return item.code === this.baseInfo.carLoanFlag
          })
          this.specialCarFlagName = specialCarFlag.text
        }
      } else {
        this.baseInfo.carLoanFlag = '0'
      }
      if (this.baseInfo.noLicenseFlag && this.baseInfo.noLicenseFlag !== null && this.baseInfo.noLicenseFlag !== undefined) {
        this.newCarFlag = this.baseInfo.noLicenseFlag=== '1' ? '0' : '1' //   // 后端0未上牌车辆；1上牌车辆，前端回显相反0上1未
      }
      console.log(returnData.itemFileDataList)
      if (returnData.itemFileDataList && returnData.itemFileDataList.length > 0) {
        this.$store.commit('setItemFileDataList', returnData.itemFileDataList)
      } else {
        this.$store.commit('setItemFileDataList', [])
      }
      if (returnData.itemFileDataList && returnData.itemFileDataList.length > 0 && returnData.itemFileDataList[0] && returnData.itemFileDataList[0].fileList.length > 0) {
        this.showNewImg = true
        const lastImg = returnData.itemFileDataList[0].fileList.filter(item => item.fileType === '56' || item.fileType === '55' || (item.fileType === '56' && item.fileType === '55'))
        // console.log(lastImg[0].fileList, 'returnData.itemFileDataList[0].fileList')
        const len = lastImg.length
        // console.log(lastImg[len - 1].fileType, 'returnData')
        this.identifyType = lastImg[len - 1].fileType === '55' ? '0' : '1'
        if (lastImg[len - 1].fileId) {
          this.$nextTick(async() => {
            // downloadFile(this.imgUrl + lastImg[len - 1].fileId, this.userToken).then(res => {
            //   this.ocrImag = res
            // })
            this.ocrImag = await getImgBase64(this.imgUrl + lastImg[len - 1].fileId, this.userToken)
          })
        }
        this.$forceUpdate()
      }
    },
    areaConfirm(value) {
      // console.log(value, '000value')
      this.motorAreaColumns.forEach(idex => {
        idex.values.filter((items, ins) => {
          if (items === value[1]) {
            this.baseInfo.proposalCityCode = idex.codeCode[ins]
          }
        })
      })
      // console.log(this.baseInfo.proposalCityCode, '--000000999999')
      localStorage.setItem('proposalCityCode',this.baseInfo.proposalCityCode)
      this.showMotorArea = false
      this.baseInfo.provinceName = value[0] + ',' + value[1]
      localStorage.setItem('provinceName', this.baseInfo.provinceName)
    },
    // 查询投保地区
    getUpProvinceCom() {
      const provParam = {
        codeType: 'DisTrictCode',
        codeLevel: '2'
      }
      // console.log(this.comName, 'this.comName')
      if (this.comName!=='HE_BEI_02') {
        this.$http.post(api.getByCodeType, provParam)
        .then(res => {
        // const resProvData = res.data
          let resProvData = []
          resProvData = res.data.filter(item => item.codeCode === this.comCode)
          const arr = {
            values: [resProvData[0].codecname],
            codeCode: resProvData[0].codeCode
          }
          this.motorAreaColumns.push(arr)
          const cityParams = {
            codeType: 'DisTrictCode',
            upperCode: resProvData[0].codeCode,
            codelevel: '3'
          }
          this.$http.post(api.getByCodeTypeAndUpperCode, cityParams)
            .then(resCity => {
              const arrs = []
              const arrCode = []
              const arrCity = {}
              resCity.data.forEach(item => {
                if(item.codeCode!=='350200') {
                  arrs.push(item.codecname)
                  arrCode.push(item.codeCode)
                  arrCity.values = arrs
                  arrCity.codeCode = arrCode
                }
              })
              this.motorAreaColumns.push(arrCity)
              // console.log(this.motorAreaColumns,'this.motorAreaColumns');
              // console.log(resCity.data,'resCity.data');
            })
            .catch(errCity => {
              console.log(errCity)
            })
        })
        .catch(error => {
          console.log(error)
        })
      } else {
        this.$http.post(api.getByCodeType, provParam)
          .then(res => {
          const resProvData = res.data
          for (const i in resProvData) {
            this.areaList.province_list[resProvData[i].codeCode] = resProvData[i].codecname
            const cityParams = {
              codeType: 'DisTrictCode',
              upperCode: resProvData[i].codeCode,
              codelevel: '3'
            }
            this.$http.post(api.getByCodeTypeAndUpperCode, cityParams)
            .then(resCity => {
              const resCityData = resCity.data
              for (const k in resCityData) {
                this.areaList.city_list[resCityData[k].codeCode] = resCityData[k].codecname
              }
            })
            .catch(errCity => {
              console.log(errCity)
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
      }
    },
    guohuChange(value) {
      console.log(value, '------')
      console.log(this.baseInfo.carLoanFlag, '------')
      if (value === '1' && this.baseInfo.carLoanFlag !== '1') {
        this.$toast('过户车的的特殊车辆标志应为“车辆所有权转移重新投保”')
        return
      } else {
        this.baseInfo.carLoanFlag = '0'
        this.specialCarFlagName = '正常车辆投保'
        this.baseInfo.makeDateJQ = ''
      }
    },
    changeType(type) {
      if (this.identifyType !== type) {
        this.clearDate()
      }
      this.identifyType = type
      // console.log(this.identifyType, 'this.identifyType')
    },
    closeTips() {
      this.showTips = false
      if (this.ocrImag && this.identifyType === '0' && !this.showTips) {
        this.touchImg()
      }
    },
    clearDate() {
      if (this.$refs.currentImg) {
        this.$refs.currentImg.style.width = ''
        this.$refs.currentImg.style.height = ''
        this.$refs.currentImg.style.marginTop = ''
        this.$refs.currentImg.style.transform = ''
      }

      // if (Object.keys(this.$store.state.motorOrderDetail).length === 0) {
      //   this.$store.commit('set_motorOrderId', '')
      //   this.showNewImg = false
      //   this.ocrImag = ''
      // }
      this.$store.commit('set_motorOrderId', '')
      this.showNewImg = false
      this.ocrImag = ''
      if (this.$refs.fileBtn) {
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
      }
      this.showTips = false
      this.licenseNo = ''
      this.carKindDetailName = ''
      this.baseInfo = {
        provinceCode: this.comCode,
        provinceName: this.baseInfo.provinceName,
        proposalCityCode: this.baseInfo.proposalCityCode,
        licenseNo: '', // 车牌号
        noLicenseFlag: '1',
        brandName: '', // 品牌型号
        oriModelName: '', // 厂牌车型
        vINNo: '', // 车架号
        engineNo: '', // 发动机号
        enrollDate: '', // 注册日期
        updateEnrollDate: '', // 注册日期调整
        carKindCode: 'M0',
        printModelName: '',
        carKindDetailId: '',
        seatCount: '',
        exhaustCapacity: '',
        power: '',
        tonCount: '',
        completekerbmass: '',
        purchasePrice: '',
        licenseKindCode: '07',
        licenseColorCode: '01',
        oriCarKindName: 'M21',
        netWorkCode: '',
        // contractNo: '',
        carLoanFlag: '0', // 特殊车辆标志
        chgOwnerFlag: '0', // 是否过户车标志 0--否 1--是
        makeDateJQ: '', // 过户登记日期
        speed: null
      }
    },
    ShowRegist() {
      this.minDate = new Date(2000, 1, 1)
      this.maxDate = new Date()
      this.currentDate = this.baseInfo.enrollDate ? new Date(this.baseInfo.enrollDate) : new Date()
      this.dateVisble = true
      this.dateStatus = 'ShowRegist'
    },
    ShowAdjust() {
      this.minDate = new Date(2000, 1, 1)
      this.maxDate = new Date()
      this.currentDate = this.baseInfo.updateEnrollDate ? new Date(this.baseInfo.updateEnrollDate) : new Date()
      this.dateVisble = true
      this.dateStatus = 'ShowAdjust'
    },
    showTransfer() {
      this.minDate = new Date(1900, 1, 1)
      this.maxDate = new Date()
      this.currentDate = this.baseInfo.makeDateJQ ? new Date(this.baseInfo.makeDateJQ) : new Date()
      this.dateVisble = true
      this.dateStatus = 'showTransfer'
    },
    dateSure(value) {
      if (this.dateStatus === 'ShowRegist') {
        this.baseInfo.enrollDate = checkFormat.getTimeToDate(value)
        this.baseInfo.updateEnrollDate = checkFormat.getTimeToDate(value)
      }
      if (this.dateStatus === 'ShowAdjust') {
        this.baseInfo.updateEnrollDate = checkFormat.getTimeToDate(value)
      }
      if (this.dateStatus === 'showTransfer') {
        this.baseInfo.makeDateJQ = checkFormat.getTimeToDate(value)
      }
      this.dateVisble = false
    },
    changSure(picker) {
      const startTime = picker.getValues()
      const startTimeValue = startTime[0] + '-' + startTime[1] + '-' + startTime[2]
      if (this.dateStatus === 'ShowRegist') {
        this.isRegist = this.baseInfo.enrollDate !== startTimeValue
      }
      if (this.dateStatus === 'ShowAdjust') {
        this.isAdjust = this.baseInfo.updateEnrollDate !== startTimeValue
      }
    },
    queryDictionary() {
      // console.log('queryDictionary')
      // console.log(this.$store.state.motorOrderDetail)
      const params = [
        { codeType: 'MotorcycleLicenseKindCode' },
        { codeType: 'MotorcycleNumberColor' },
        { codeType: 'CarClassNameCode' },
        { codeType: 'MotorcyclesSpecialCarFlag' },
        { codeType: 'MotorcycleVehicleType' },
        { codeType: 'ColorCode' }
      ]
      this.switchs = true
      this.$http.post(api.getByMoreCodeType, params)
        .then(res => {
          this.switchs = false
          if (res.data.rtnCode === '0000') {
            this.dictionaryData = res.data.result
            res.data.result.forEach(item => {
              if (item.upperCode === this.baseInfo.carKindCode) {
                const detailObj = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.carKindDetailColumns.push(detailObj)
              }
              if (item.codeType === 'MotorcycleLicenseKindCode') {
                const kindObj = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.licenseKindColumns.push(kindObj)
              }
              if (item.codeType === 'MotorcycleNumberColor') {
                const colorObj = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.licenseColorColumns.push(colorObj)
              }
              if (item.codeType === 'MotorcyclesSpecialCarFlag') {
                const flagObj = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.specialCarFlagColumns.push(flagObj)
              }
              if (item.codeType === 'MotorcycleVehicleType') {
                const ori = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.carTypeColumns.push(ori)
              }
              if (item.codeType === 'ColorCode') {
                const color = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.colorCodeColumns.push(color)
              }
            })
            console.log(this.$store.state.motorOrderDetail, '----motorOrderDetail')
            if (this.$store.state.motorOrderDetail && Object.keys(this.$store.state.motorOrderDetail).length > 0) {
              // this.sendChanges = true
              this.orderNo = this.$store.state.motorOrderDetail.orderNo
              this.getMortorQuery()
            }
          } else {
            Toast(res.data.rtnMsg)
          }
        })
        .catch(error => {
          this.switchs = false
          console.log(error)
        })
    },
    confirm(value, type) {
      console.log(value, type);
      if (type === 'carKindDetail') {
        console.log(value, 'carKindDetail');
        this.baseInfo.carKindDetailId = value.code
        this.carKindDetailName = value.text
        this.showCarKindDetail = false
      }
      if (type === 'oriCarKind') {
        console.log(value, 'oriCarKind');
        this.baseInfo.oriCarKindName = value.code
        this.oriCarKindName = value.text
        this.showCarType = false
      }
      if (type === 'licenseKind') {
        this.baseInfo.licenseKindCode = value.code
        this.licenseKindName = value.text
        this.showLicenseKind = false
      }
      if (type === 'licenseColor') {
        this.baseInfo.licenseColorCode = value.code
        this.licenseColorName = value.text
        this.showLicenseColor = false
      }
      if (type === 'specialFlag') {
        this.baseInfo.carLoanFlag = value.code
        this.specialCarFlagName = value.text
        this.showSpecialCarFlag = false
      }
      if (type === 'colorCode') {
        this.baseInfo.colorCode = value.code
        this.colorCodeName = value.text
        this.showColorCodeFlag = false
      }
    },
    toModelList() {
      if (!this.baseInfo.brandName) {
        Toast({
          message: '品牌型号不能为空',
          icon: 'info-o'
        })
      } else {
        this.$router.push({
          name: 'carModelList',
          params: {
            brandName: this.baseInfo.brandName,
            comCode: this.comCode,
            orderNo: this.orderNo
          }
        })
      }
    },
    // OCR识别 0--合格证 1--行驶证
    handleFile(event) {
      const file = event.target.files[0]
      if (!file) return
      // 禁止的格式
      const forbidden = ['html', 'htm', 'svg'];
      const ext = file.name.toLowerCase().split('.').pop();
      if (forbidden.includes(ext)) {
        this.$toast('不支持上传 html/htm/svg 文件！')
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件; // 清空选择
        return
      }
      console.log(this.$refs.fileBtn, 'fileBtn')
      if (this.$refs.fileBtn) {
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
      }
      if (file.size > 20 * 1000 * 1000) {
        this.$toast('图片大小超过20M，请重新选择')
        return false
      } else {
        const that = this
        new Compressor(file, {
          quality: 0.5,
          maxWidth: 1200,
          success(result) {
            const reader = new FileReader()
            reader.readAsDataURL(result)
            reader.onload = function(e) {
              const name = new Date().getTime()
              const param = {
                fileName: that.identifyType + name + '.png',
                imageInBase64Format: e.target.result,
                serviceProvider: 'INTSIG', // 服务提供商
                businessType: 'OfficialWX-CarInsuranceInfo', // 系统业务类型：0核心业务系统（0电子投保单；1电子保单；）1数字化营销平台销管中心（0电子合同），必传
                systemOrigin: 'OfficialWX', // 系统来源（0核心业务系统；1数字化营销平台销管中心），必传
                businessNo: checkFormat.generateUUID() // 系统业务唯一标识（投保单号、保单号、个人代理人唯一标识），必传
              }
              // console.log(that.identifyType, 'that.identifyType')
              // console.log(name, 'name')
              const apiUrl = that.identifyType === '0' ? api.vehicle_certificates : api.vehicle_licenses
              that.ocrImag = e.target.result
              that.showNewImg = true
              that.$nextTick(() => {
                that.$refs.currentImg.style.width = ''
                that.$refs.currentImg.style.height = ''
                that.$refs.currentImg.style.transform = `rotate(-${that.imgDeg}deg)`
              })
              that.imgDeg = 0
              that.switchs = true
              that.$http.post(apiUrl, param).then(res => {
                that.switchs = false
                if (res.data.rtnCode === '0000') {
                  if (that.identifyType === '0' && res.data.issueDate) {
                    const year = res.data.issueDate.substring(0, res.data.issueDate.indexOf('年'))
                    const month = res.data.issueDate.substring(res.data.issueDate.indexOf('年') + 1, res.data.issueDate.indexOf('月'))
                    const date = res.data.issueDate.substring(res.data.issueDate.indexOf('月') + 1, res.data.issueDate.indexOf('日'))
                    res.data.issueDate = `${year}-${month}-${date}`
                  }
                  that.licenseNo = that.identifyType === '1' ? res.data.plateNo : ''
                  // console.log(that.licenseNo, 'that.licenseNo');
                  if (that.licenseNo) {
                    if (that.comName!=='HE_BEI_02') {
                      if (that.baseInfo.proposalCityCode === '330200' || that.comName === 'XIA_MEN') {
                        that.licenseNo = that.licenseNo.substring(2)
                      } else {
                        that.licenseNo = that.licenseNo.substring(1)
                      }
                    } else {
                      that.baseInfo.licenseNo = that.licenseNo
                    }
                  }
                  that.baseInfo.vINNo = that.identifyType === '0' ? res.data.vehicleVin : res.data.vin
                  that.baseInfo.engineNo = res.data.engineNo
                  that.baseInfo.enrollDate = that.identifyType === '1' ? res.data.registerDate : ''
                  that.baseInfo.updateEnrollDate = that.identifyType === '1' ? res.data.registerDate : ''
                  that.baseInfo.brandName = that.identifyType === '0' ? res.data.vehicleModelNo : res.data.model
                  that.baseInfo.printModelName = that.identifyType === '0' ? res.data.vehicleModelNo : res.data.model
                  that.baseInfo.exhaustCapacity = that.identifyType === '0' ? res.data.displacement : ''
                  that.baseInfo.power = that.identifyType === '0' ? res.data.power : ''
                  that.baseInfo.completekerbmass = that.identifyType === '0' ? res.data.curbWeight : ''
                  that.imgobjs = {}
                  // console.log(param.fileName, 'param.fileName')
                  that.imgobjs = {
                    fileId: res.data.fileId,
                    fileType: that.identifyType === '0' ? '55' : '56',
                    fileName: param.fileName
                  }
                  that.$toast('请注意核对自动识别出的信息是否正确')
                  that.toModelList()
                } else {
                  that.$toast(res.data.rtnMsg)
                }
              })
                .catch(err => {
                  console.log(err)
                  this.switchs = false
                })
            }
          }
        })
      }
    },
    // 图片旋转
    rotateImg() {
      if (this.displacement.moveEnd && this.identifyType === '0') {
        this.$refs.currentImg.style.transform = ''
        this.$refs.currentImg.style.transformOrigin = ''
        this.$refs.currentImg.style.top = ''
        this.$refs.currentImg.style.left = ''
        this.displacement.moveEnd = false
      }
      const img = new Image()
      img.src = this.ocrImag
      this.imgDeg += 90
      if (this.imgDeg >= 360) {
        this.imgDeg = 0
      }
      if (this.imgDeg === 90 || this.imgDeg === 270) {
        if (Number(img.width) > Number(img.height)) {
          this.$refs.currentImg.style.height = `${0.62 * 209}px`
          this.$refs.currentImg.style.width = '209px'
          this.$refs.currentImg.style.marginTop = (126 / 3.1) + 'px'
        }
      } else {
        if (Number(img.width) > Number(img.height)) {
          this.$refs.currentImg.style.width = img.width + 'px'
          this.$refs.currentImg.style.height = img.height + 'px'
        }
        this.$refs.currentImg.style.marginTop = 0
      }
      this.$refs.currentImg.style.transform = `rotate(${this.imgDeg}deg)`
    },
    // 放大图片
    enlargeImg() {
      this.$ImagePreview([this.ocrImag])
    },
    touchImg() {
      const that = this
      let position_left = ''
      let position_top = ''
      this.$nextTick(() => {
        // 获取放大缩小的区域DOM
        const imgBox = that.$refs.currentImg
        // const imgBox = document.querySelector('.new-img')
        imgBox.addEventListener('touchstart', function(event) {
          const touches = event.touches
          const events = touches[0]
          const events2 = touches[1]
          //  第一个触摸点的坐标
          that.displacement.pageX = events.pageX
          that.displacement.pageY = events.pageY
          that.displacement.moveable = true
          if (events2) {
            that.displacement.pageX2 = events2.pageX
            that.displacement.pageY2 = events2.pageY
          }
          if (touches.length === 0) {
            const _obj = this.$refs.currentImg
            position_left = parseFloat(_obj.css('left').split('p')[0])
            position_top = parseFloat(_obj.css('top').split('p')[0])
          }
          that.displacement.originScale = that.displacement.scale || 1
        })
        document.addEventListener('touchmove', function(event) {
          if (!that.displacement.moveable) {
            return
          }
          event.preventDefault()
          const touches = event.touches
          const events = touches[0]
          const events2 = touches[1]
          // 双指移动
          if (events2) {
          //   第二个手指坐标在touchmove时候获取
            if (!that.displacement.pageX2) {
              that.displacement.pageX2 = events2.pageX
            }
            if (!that.displacement.pageY2) {
              that.displacement.pageY2 = events2.pageY
            }
            //  双指缩放比例计算
            const numerator = that.getDistance(
              {
                x: events.pageX,
                y: events.pageY
              },
              {
                x: events2.pageX,
                y: events2.pageY
              }
            )
            const denominator = that.getDistance(
              {
                x: that.displacement.pageX,
                y: that.displacement.pageY
              },
              {
                x: that.displacement.pageX2,
                y: that.displacement.pageY2
              }
            )
            const zoom = numerator / denominator
            // 应用在元素上的缩放比例
            const newScale = that.displacement.originScale * zoom
            // 最大缩放比例限制
            // if (newScale > 1) {
            //   newScale = 1
            // }
            //   记住使用的缩放值
            that.displacement.scalar = newScale
            //   图像应用缩放效果
            imgBox.style.transform = `scale(${newScale})`
            //  设置旋转元素的基点位置
            imgBox.style.transformOrigin = '0px 0px 0px'
          } else if (touches.length === 0) {
            imgBox.css({
              'top': position_top + events.pageY - that.displacement.pageY + 'px',
              'left': position_left + events.pageX - that.displacement.pageX + 'px'
            })
          }
        })
        document.addEventListener('touchend', function(event) {
          that.displacement.moveable = false
          that.displacement.moveEnd = true
          delete that.displacement.pageX
          delete that.displacement.pageY
        })
      })
    },
    getDistance(start, stop) {
    // Math.hypot() 计算参数平方根
      return Math.hypot(stop.x - start.x, stop.y - start.y)
    },
    changName(value) {
      this.isBrandName = !!(this.baseInfo.oriModelName && value)
    },
    changVINNo(value) {
      this.isvINNo = !!(this.baseInfo.oriModelName && value)
    },
    changEngineNo(value) {
      this.isEngineNo = !!(this.baseInfo.oriModelName && value)
    },
    submit() {
      // console.log(this.baseInfo.provinceName, 'baseInfo.provinceName');
      if (!this.baseInfo.vehicleId) {
        this.baseInfo.vehicleId = localStorage.getItem('vehicleId')
      }
      console.log(this.baseInfo, 'baseInfo')
      if (!this.baseInfo.provinceName) {
        Toast('投保地区不能为空')
        return
      }
      if (!this.baseInfo.speed) {
        Toast('时速不能为空')
        return
      }
      this.baseInfo.noLicenseFlag = this.newCarFlag === '1' ? '0' : '1'
      if (this.comName !== 'HE_BEI_02') {
        this.baseInfo.licenseNo = `${this.licenseNoName}${this.licenseNo}`
      }
      // 判断表单信息是否为空
      if (this.baseInfo.noLicenseFlag === '0') {
        for (const keys in motorReminder) {
          if (keys !== 'licenseNo') {
            if (this.baseInfo[keys] === '' || this.baseInfo[keys] === null || this.baseInfo[keys] === undefined) {
              this.$toast(motorReminder[keys] + '不能为空')
              return false
            }
          }
        }
      } else {
        for (const keys in motorReminder) {
          if (this.baseInfo[keys] === '' || this.baseInfo[keys] === null || this.baseInfo[keys] === undefined) {
            this.$toast(motorReminder[keys] + '不能为空')
            return false
          }
        }
      }
      if (this.newCarFlag === '0') {
        if (!checkFormat.isVehicleNumber(this.baseInfo.licenseNo)) {
          this.$toast('请填写正确的车牌号')
          return false
        } else {
          if (this.comName === 'FU_JIAN' && this.licenseNo.startsWith('D')) {
            Dialog.alert({
              message: '尊敬的客户：你好，本平台目前仅支持为持有福建地区（不含厦门）机动车行驶证的国产燃油摩托车自然人车主提供交强险便民投保服务，其他车辆如需投保，请线下联系保险公司投保，谢谢！',
              confirmButtonText: '我知道了',
              confirmButtonColor: '#5E2589'
            }).then(() => {
              // on close
              // this.licenseNoName = ''
            })
            return false
          }
        }
      } else {
        this.baseInfo.licenseNo = ''
      }
      console.log(this.baseInfo.licenseNo, 'this.baseInfo.licenseNo');
      const add = /^[0-9a-zA-Z]+$/
      for (var i = 0; i < this.baseInfo.vINNo.length; i++) {
        if (!add.test(this.baseInfo.vINNo[i])) {
          Toast('车架号只能是字母或数字')
          return false
        }
      }
      if (this.baseInfo.seatCount === '0' || this.baseInfo.seatCount === 0) {
        Toast('座位不能小于0')
        return false
      }
      if (this.baseInfo.carLoanFlag === '1') {
        console.log(this.baseInfo.makeDateJQ, 'this.baseInfo.makedateJQ')
        if (!this.baseInfo.makeDateJQ) {
          Toast('过户登记日期不能为空')
          return
        }
      }
      if (!this.baseInfo.speed) {
        Toast('时速不能为空')
        return
      }
      if (!this.baseInfo.colorCode) {
        Toast('车身颜色不能为空')
        return
      }
      if ((this.baseInfo.carKindDetailId === 'MD' && (Number(this.baseInfo.speed)) > 50) || this.baseInfo.carKindDetailId === 'ME' && (Number(this.baseInfo.speed) < 50)) {
        this.$toast(this.carKindDetailName)
        return false
      }
      if (this.nextNum > 0) {
        if (this.isBrandName || this.isvINNo || this.isEngineNo || this.isRegist || this.isAdjust) {
          Toast('请重新识别厂牌车型')
          return false
        }
      }
      this.temporary('save')
    },
    toOrderList() {
      if (this.$store.state.motorOrderId) {
        this.temporary('orderList')
      } else {
        this.$router.push('/motor/orderList')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/pages/motor/components/baseInfo/index.vue